<section [ngClass]="dynamicClass">
  <div class="eq-container">
    <div class="eq-flex eq-flex-col eq-gap-y-[18px] eq-mb-[44px] eq-mx-auto eq-text-center lg:eq-gap-y-[44px] lg:eq-mb-10 lg:eq-max-w-[956px]">
      <h2 *ngIf="rendering.fields?.Title?.value" class="eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue lg:eq-text-heading2">
        {{ rendering.fields?.Title?.value }}
      </h2>
      <div *ngIf="rendering.fields?.Subtitle?.value" class="eq-text-body-subtitle-m eq-text-black-natural-60 lg:eq-text-body-subtitle">
        {{ rendering.fields?.Subtitle?.value }}
      </div>
    </div>
    <div class="eq-grid eq-grid-cols-1 eq-grid-flow-row eq-gap-5 lg:eq-grid-cols-2 lg:eq-gap-[20px]">
      <ng-container *ngFor="let card of cards">
        <app-card-product 
          [cardData]="card"
        ></app-card-product>
      </ng-container>
    </div>
  </div>
</section>
